<template>
  <component :is="layoutComponent" :field="field" :errors="errors">
    <template slot="field">
      <div>
        <div class="half-width">
          <div v-for="(day, index) in days" :key="day" class="hours row">
            <div class="custom-control custom-checkbox">
              <input
                :id="'customCheck' + index"
                :checked="isOpen(day)"
                type="checkbox"
                class="custom-control-input"
                @change="toggleOpen(day)"
              />
              <label
                :for="'customCheck' + index"
                class="custom-control-label check-text"
              >
                {{ $t(capitalize(day)) }}
              </label>
            </div>
            <template v-if="isOpen(day)">
              <div class="ml-auto">
                <flat-pickr
                  v-model="fieldValue[day].gte"
                  type="text"
                  class="hours__time ml-3"
                  placeholder="hh:mm"
                  :config="flatpickrConfig"
                />
                <flat-pickr
                  v-model="fieldValue[day].lte"
                  type="text"
                  class="hours__time"
                  placeholder="hh:mm"
                  :config="flatpickrConfig"
                />
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
  </component>
</template>

<script>
import FormWorkingHoursField from "../../../common/FormWorkingHoursField.vue";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "FormCustomWorkingHoursField",

  extends: FormWorkingHoursField,

  methods: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>
